export function browserMeasurements(window) {
    if (typeof window === 'undefined') {
        return null;
    }

    return {
        browserWidth: window.innerWidth,
        browserHeight: window.innerHeight,
        screenWidth: window.screen.availWidth,
        screenHeight: window.screen.availHeight,
        screenPixelRatio: window.devicePixelRatio,
    };
}
